import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg"

const IconeSuiviObjectifs = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={57} height={57} fill="none" viewBox="0 0 57 57" {...props}>
            <Rect width={57} height={57} fill="#fff" rx={10} />
            <G clipPath="url(#clip0)">
                <Path
                    fill={baseColors.green.primary}
                    d="M36.686 15.398h-14.29a3.23 3.23 0 00-.465.034v21.816l14.884-.402.632-20.688a.76.76 0 00-.76-.76z"
                />
                <Path
                    fill={baseColors.green.dark}
                    d="M35.854 16.158v18.124h1.593V16.159a.76.76 0 00-.76-.76h-1.594c.42 0 .76.34.76.76zm-13.2-.76h-.448a3.06 3.06 0 00-3.051 3.05v18.82l3.5.477V15.398z"
                />
                <Path fill={baseColors.black} d="M22.206 15.398c-.404 0-.79.08-1.145.224v22.123h1.593V15.398h-.448z" />
                <Path
                    fill={baseColors.green.dark}
                    d="M36.674 39.832H21.67a2.515 2.515 0 110-5.031h15.777v1.25l-1.062 1.265 1.062 1.266v.477a.773.773 0 01-.773.773z"
                />
                <Path
                    fill="#FFF9F5"
                    d="M21.67 38.582a1.267 1.267 0 01-1.266-1.266c0-.698.568-1.265 1.266-1.265h15.777v2.53H21.67z"
                />
                <Path fill="#FFF9F5" d="M34.792 36.05h2.655v2.532h-2.655V36.05z" />
                <Path
                    fill={baseColors.orange.primary}
                    d="M34.196 25.65l-4.204 4.205a.563.563 0 01-.797 0L24.99 25.65a.563.563 0 010-.796l4.204-4.205c.22-.22.576-.22.796 0l4.205 4.205c.22.22.22.576 0 .796z"
                />
                <Path
                    fill="#FFF9F5"
                    d="M34.196 24.854l-4.204-4.205a.563.563 0 00-.797 0l-.398.399 3.805 3.806c.22.22.22.576 0 .796l-3.805 3.806.398.399c.22.22.576.22.796 0l4.205-4.205a.563.563 0 000-.796z"
                />
                <Path
                    fill="#FFF9F5"
                    d="M30.937 25.758l-.838.838a.715.715 0 01-1.011 0l-.838-.838a.715.715 0 010-1.011l.838-.838a.715.715 0 011.01 0l.839.838a.714.714 0 010 1.01z"
                />
                <Path
                    fill={baseColors.orange.primary}
                    d="M32.633 36.05v5.611c0 .255.21.418.384.3l.81-.545a.212.212 0 01.248.002l.761.532c.176.122.389-.042.389-.298V36.05l-1.296.683-1.296-.683z"
                />
                <Path fill="#FFF9F5" d="M32.633 36.05h2.592v2.052h-2.592V36.05z" />
                <Path
                    fill={baseColors.orange.primary}
                    d="M36.73 15h-3.728a.398.398 0 00-.398.398v1.217c0 .348.283.632.631.632h.98c.763 0 1.384.62 1.384 1.384v.801c0 .348.283.631.631.631h1.217c.22 0 .398-.178.398-.398v-3.55c0-.615-.5-1.115-1.114-1.115zm.717 15.136H36.23a.632.632 0 00-.631.63v.803c0 .763-.621 1.384-1.384 1.384h-.98a.632.632 0 00-.631.63v1.218c0 .22.178.398.398.398h3.729c.614 0 1.114-.5 1.114-1.114v-3.55a.398.398 0 00-.398-.4z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h27v27H0z" transform="translate(15 15)" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default IconeSuiviObjectifs
